import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import Specialization3 from '../Elements/Specialization3';
import AllServices2 from '../Elements/AllServices2';
import OurServices from '../Elements/OurServices';
import AllServices from '../Elements/AllServices';
import AllServices3 from '../Elements/AllServices3';
import OurValue3 from '../Elements/OurValue3';
import OurProject2 from '../Elements/OurProject2';
import Faq from '../Elements/Faq';
import { NavLink } from 'react-router-dom';

var bnrimg = require('./../../images/banner/7.jpg');
var bnr1 = require('./../../images/background/bg-6.png');


class Mobilne extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner title="Mobilne Przeszkody/Przydomowe Skateparki " pagename="Usługi" bgimage={bnrimg}/>
                    <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/services/s5.webp')} alt=" A scene depicting slightly older, yet still young skatepark designers actively working on a project using CAD software on a computer. "/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                    <div className="service-about-right m-b30">
    <h3 className="m-t0">Czasem lokalny skatepark to za mało.</h3>
    <p>Dla klientów indywidualnych mamy bogatą ofertę przeszkód: mobilne, miniaturowe, przydomowe, na
wynajem, prefabrykowane w częściach z instrukcją do samodzielnego złożenia,
skręcone gotowe do natychmiastowego montażu.<p></p>
Projektujemy indywidualne przeszkody, nie ma dla nas pomysłu, którego nie zdołamy przekuć w
rzeczywistość.<p></p>
Mniejsze marzenia realizujemy w naszym SKLEPIE, klientów z większymi, nie standardowymi potrzebami
prosimy o kontakt bezpośredni.</p>
    <div className="call-for-quote-outer">
        <div className="call-quote">
            <span>Potrzebujesz mobilnych przeszkód?  Skontaktuj się z nami!</span>
            <h4 >PL +48 500 073 261</h4>
                                <h4>ENG/PL +48 602 762 478</h4>
        </div>
        <div className="call-estimate bg-dark">
        <a href={`mailto:biuro@skate-arena.pl?subject=Wypożyczenie lub sprzedaż mobilnych przeszkód skateparku w [MIEJSCE]&body=${encodeURIComponent("Dzień dobry,\n\nZainteresowała mnie oferta Państwa usług wypożyczenia lub sprzedaży mobilnych przeszkód skateparku. Proszę o przesłanie dalszych informacji dotyczących możliwości współpracy oraz szczegółów technicznych. Oto moje dane kontaktowe:\nTelefon: [Twój numer telefonu]\nPozdrawiam,\n\n[Twoje Imię i Nazwisko]")}`} className="site-button">
    lub wyślij do nas email!
</a>
        </div>
    </div>
</div>

</div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
         
                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default Mobilne;